var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',[_c('div',{staticClass:"box"},[_c('el-checkbox',{model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}}),_c('span',{staticClass:"gray12Span"},[_vm._v("阅读并接受")]),_c('span',{staticClass:"href",on:{"click":_vm.toHref}},[_vm._v("《用户保护协议》")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }